import FixedReports from "@pages/Reports/Fixed Reports";
import ReportsLicense from "@pages/Reports/License";
import ReportLicenseAdd from "@pages/Reports/License/Add";
import ReportsLicenseDetail from "@pages/Reports/License/Detail";
import ReportsPECompliance from "@pages/Reports/PECompliance";
import ReportPEComplianceAdd from "@pages/Reports/PECompliance/Add";
import ReportsPEComplianceDetail from "@pages/Reports/PECompliance/Detail";
import ReportsVendorAudit from "@pages/Reports/VendorAudit";
import ReportVendorAuditAdd from "@pages/Reports/VendorAudit/Add";
import ReportsVendorAuditDetail from "@pages/Reports/VendorAudit/Detail";
import ReportsVendorAuditUploads from "@pages/Reports/Fixed Reports/VendorAudit/VendorAuditUploads";
import ReportsHeadCount from "@pages/Reports/Fixed Reports/HeadCount/HeadCountReports";
import ReportsDailyAudit from "@pages/Reports/Fixed Reports/VendorAudit/DailyAudit";
import ReportsDailyUpload from "@pages/Reports/Fixed Reports/VendorAudit/DailyUpload";
import ConsolidateReports from "@pages/Reports/Fixed Reports/VendorAudit/ConsolidateReports";
import ComplianceTaskReport from "@pages/Reports/Fixed Reports/VendorAudit/ComplianceTask";
import SelfComplianceReports from "@pages/Reports/SelfCompliance";
import RepositoryMasterReports from "@pages/Reports/SelfCompliance/Repository/MasterReports";
import ReportsLegalUpdate from "@pages/Reports/LegalUpdate";
import VendorAuditReport from "@pages/Reports/Fixed Reports/VendorAuditReport";

export const ReportRoutes = [
  // vendor audit
  {
    path: "/report/vendor-audit",
    name: "report_analytics_vendor_audit",
    component: ReportsVendorAudit,
  },
  {
    path: "/report/vendor-audit-uploads",
    name: "report_analytics_vendor_audit",
    component: ReportsVendorAuditUploads,
  },
  {
    path: "/report/vendor-audit/add",
    name: "report_analytics_vendor_audit",
    component: ReportVendorAuditAdd,
  },
  {
    path: "/report/vendor-audit/:id",
    name: "report_analytics_vendor_audit",
    component: ReportsVendorAuditDetail,
  },

  // PE Compliance
  {
    path: "/report/pe-compliance",
    name: "report_analytics_pe_compliance",
    component: ReportsPECompliance,
  },
  {
    path: "/report/pe-compliance/:id",
    name: "report_analytics_pe_compliance",
    component: ReportsPEComplianceDetail,
  },
  {
    path: "/report/pe-compliance/add",
    name: "report_analytics_pe_compliance",
    component: ReportPEComplianceAdd,
  },
  // License
  {
    path: "/report/license",
    name: "report_analytics_license",
    component: ReportsLicense,
  },
  {
    path: "/report/license/add",
    name: "report_analytics_license",
    component: ReportLicenseAdd,
  },
  {
    path: "/report/license/:id",
    name: "report_analytics_license",
    component: ReportsLicenseDetail,
  },

  // fixed reports
  // vendor audit
  {
    path: "/report/fixed-reports",
    name: "report_fixed_report",
    component: FixedReports,
  },


  {
    path: "/report/fixed-reports/vendor-audit-uploads",
    name: "report_analytics_fixed_report",
    component: ReportsVendorAuditUploads,
  },
  {
    path: "/report/fixed-reports/vendor-daily-audit",
    name: "report_analytics_fixed_report",
    component: ReportsDailyAudit,
  },
  {
    path: "/report/fixed-reports/vendor-daily-uploads",
    name: "report_analytics_fixed_report",
    component: ReportsDailyUpload,
  },
  {
    path: "/report/fixed-reports/consolidated-audit-reports",
    name: "report_analytics_fixed_report",
    component: ConsolidateReports,
  },
  {
    path: "/report/fixed-reports/compliance-task-reports",
    name: "report_analytics_fixed_report",
    component: ComplianceTaskReport,
  },
  //self compliance reports
  {
    path: "/report/self-compliance-reports",
    name: "report_analytics_self_compliance",
    component: SelfComplianceReports,
  },
  {
    path: "/report/self-compliance-reports/repository-master-reports",
    name: "report_analytics_self_compliance",
    component: RepositoryMasterReports,
  },
  
  //vendor
  {
    path: "/report/fixed-reports/headcount",
    name: "report_analytics_fixed_report",
    component: ReportsHeadCount,
  },

  {
    path: "/report/fixed-reports/vendor-audit",
    name: "report_analytics_fixed_report",
    component: VendorAuditReport,
  },
];
